
import { Box, Button, Grid, Typography, Stack, useTheme, useMediaQuery } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { ExternalUrls } from '../../../lib/constants';


const features = [
    'Custom On-site Setup & Training',
    'Advanced Outcomes Reporting & Analytics',
    'DTAC / EPR / Clinical Governance',
    'Data Protection Impact Assessments (DPIA)'
];

export function PricingEnterpriseCallout() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box
            sx={{
                maxWidth: 'lg',
                mx: 'auto',
                mt: 6,
                mb: 6,
                px: { xs: 0, md: 4 } // Align with section container padding
            }}
        >
            <Box
                sx={{
                    bgcolor: 'transparent',
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    p: { xs: 3, md: 4 },
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <Grid container spacing={4} alignItems="center">
                    {/* Left: Content & CTA */}
                    <Grid item xs={12} md={5}>
                        <Typography
                            variant="h4"
                            component="h3"
                            gutterBottom
                            sx={{ fontWeight: 700 }}
                        >
                            Enterprise, NHS & Large Providers
                        </Typography>

                        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 3 }}>
                            Tailored solutions for NHS trusts, hospitals, and large therapy providers
                        </Typography>


                        <Button
                            href={ExternalUrls.calendly}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="outlined"
                            size="medium"

                            fullWidth={isMobile}
                            sx={{
                                borderRadius: 1,
                                fontWeight: 700,
                                letterSpacing: 0.5,
                                py: 1.5,
                            }}
                        >
                            Book a Consultation
                        </Button>
                    </Grid>

                    {/* Right: Feature List */}
                    <Grid item xs={12} md={7}>
                        <Grid container spacing={2}>
                            {features.map((feature, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                        <CheckIcon color="primary" sx={{ fontSize: 20, mt: 0.5 }} />
                                        <Typography variant="body2" fontWeight={500} color="text.primary">
                                            {feature}
                                        </Typography>
                                    </Stack>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
